export function normalizeLink(to) {
  if (typeof to !== 'string') return to;

  const link = to.trim();
  if (!link || /^(?:[a-z][a-z\d+.-]*:|\/|#|\?)/i.test(link)) return link;
  return `https://${link}`;
}

function Link(props = { text, to }) {
  const { text, to, ...attributes } = props;

  return (
    <a {...attributes} href={normalizeLink(to)} target='_blank' rel='noopener noreferrer'>
      {text}
    </a>
  );
}

export default Link;
